import { render, staticRenderFns } from "./SectorWarBoard.vue?vue&type=template&id=dd2a79a4&scoped=true"
import script from "./SectorWarBoard.vue?vue&type=script&lang=js"
export * from "./SectorWarBoard.vue?vue&type=script&lang=js"
import style0 from "./SectorWarBoard.vue?vue&type=style&index=0&id=dd2a79a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2a79a4",
  null
  
)

export default component.exports